import React from "react";
import Layout from "../../components/layout";
import { MdAdd } from "react-icons/md";
import { Alert, Button, Snackbar } from "@mui/material";
import { useState } from "react";
import Spinner from "../../components/spinner";
import useRead from "../../hooks/useRead";
import useCreate from "../../hooks/useCreate";
import { SuccessAlert } from "../../components/alerts/Alerts";
import { toast } from "react-hot-toast";
import SwitchToggle from "../../components/elements/switchtoggle/SwitchToggle";
import DeleteModal from "../../components/elements/deleteModal";

const Taxes = () => {
  let initialState = {
    pageNo: 0,
    limit: 20,
    searchQuery: "",
  };
  const [isDeletedSuccess, setIsDeletedSuccess] = useState(false);
  const [isCreatedSuccess, setIsCreatedSuccess] = useState(false);
  const [isUpdatedSuccess, setIsUpdatedSuccess] = useState(false);
  const [taxData, setTaxData] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [taxToDeleteIdx, setTaxToDeleteIdx] = useState(null);

  const handleAddTaxField = () => {
    let newField = {
      name: "",
      value: "",
    };
    setTaxData((prevData) => [newField, ...prevData]);
  };

  const {
    data: list,
    paramsObject,
    setGetListParams,
  } = useRead({
    url: "tax/list",
    initialData: initialState,
    method: "GET",
    onSuccess: (data) => {
      setTaxData(data.data);
    },
  });

  const total_count = list?.data?.count;

  const handlePageClick = (val) => {
    let data = {
      ...paramsObject,
      pageNo: val.selected,
    };
    setGetListParams(data);
  };

  const handleSearchVal = (e) => {
    let value = e.target.value;
    let data = {
      ...paramsObject,
      searchQuery: searchVal,
      [e.target.name]: value,
    };
    setGetListParams(data);
  };

  const handleChangeInput = (e, idx) => {
    let copyData = taxData;
    let $this = e.currentTarget;
    copyData[idx][$this.name] = $this.value;
    setTaxData([...taxData]);
  };
  const handleDeleteTaxField = (fieldID) => {
    const temp = taxData[fieldID];
    // If tax not saved yet (no id), remove it locally
    if (!temp?.id) {
      setTaxData((prev) => prev.filter((_, i) => i !== fieldID));
      return;
    }
    // Open modal for saved tax
    setTaxToDeleteIdx(fieldID);
    setDeleteModalOpen(true);
  };

  const handleConfirmDelete = () => {
    const temp = taxData[taxToDeleteIdx];
    setDeleteTaxToServer.mutate({ id: temp.id });
    setDeleteModalOpen(false);
    setTaxToDeleteIdx(null);
  };

  const { setDataToServer: setCreateTaxToServer } = useCreate({
    refreshUrl: "tax/list",
    url: "tax/create",
    onSuccess: () => {
      setIsCreatedSuccess(true);
      toast.success("Tax Created Successfully", {
        position: "top-right",
        duration: 3000,
      });
    },
    onError: () => {},
  });

  const { setDataToServer: setUpdateTaxToServer } = useCreate({
    refreshUrl: "tax/list",
    url: "tax/update",
    onSuccess: () => {
      setIsUpdatedSuccess(true);
      toast.success("Tax Updated Successfully", {
        position: "top-right",
        duration: 3000,
      });
    },
    onError: () => {},
  });

  const { setDataToServer: setDeleteTaxToServer } = useCreate({
    refreshUrl: "tax/list",
    url: "tax/delete",
    onSuccess: () => {
      setIsDeletedSuccess(true);
      toast.success("Tax Deleted Successfully", {
        position: "top-right",
        duration: 3000,
      });
    },
    onError: () => {},
  });

  const handleSubmitForm = (e, idx) => {
    e.preventDefault();
    const temp = taxData[idx];
    if (temp?.id) {
      // Update: send id, name, value
      setUpdateTaxToServer.mutate({
        id: temp.id,
        name: temp.name,
        value: temp.value,
      });
    } else {
      // Create: send only name, value
      setCreateTaxToServer.mutate({
        name: temp.name,
        value: temp.value,
      });
    }
  };

  return (
    <div className="container mx-auto px-4 py-6">
      {/* <Layout> */}
      <div className="category">
        <div className="category__head headingBorder__b">
          <h2 className="titleHeading">Taxes</h2>
        </div>
        <div className="category_table py-5 space-y-5">
          <div className="flex-1">
            <input
              type="text"
              onChange={handleSearchVal}
              value={paramsObject.searchQuery}
              name="searchQuery"
              placeholder="Search Taxes...."
              className="input"
            />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
            <CreateTax onAddField={handleAddTaxField} />
            {taxData.map((form, idx) => {
              return (
                <TaxForm
                  key={idx}
                  data={form}
                  onChange={(e) => handleChangeInput(e, idx)}
                  onDelete={() => handleDeleteTaxField(idx)}
                  onSubmit={(e) => handleSubmitForm(e, idx)}
                />
              );
            })}
          </div>
        </div>
      </div>
      {/* </Layout> */}
      <SuccessAlert
        visible={isDeletedSuccess}
        onClose={() => setIsDeletedSuccess(false)}
        text={"Tax Item Deleted Succesfully"}
      />
      <SuccessAlert
        visible={isCreatedSuccess}
        onClose={() => setIsCreatedSuccess(false)}
        text={"Tax Item Create Succesfully"}
      />
      <SuccessAlert
        visible={isUpdatedSuccess}
        onClose={() => setIsUpdatedSuccess(false)}
        text={"Tax Item Updated Succesfully"}
      />
      <DeleteModal
        open={isDeleteModalOpen}
        handleClose={() => setDeleteModalOpen(false)}
        title={"Delete Tax"}
        message={"Are you sure you want to delete this tax?"}
        onDelete={handleConfirmDelete}
      />
    </div>
  );
};

const CreateTax = ({ onAddField }) => {
  return (
    <button
      onClick={onAddField}
      className="border bg-white hover:border-solid hover:shadow-lg border-gray-600 cursor-pointer rounded-md border-dashed flex flex-col items-center justify-center select-none h-[15.7rem]"
    >
      <MdAdd className="w-16 h-16 text-gray-600" />
      <span className="text-gray-600">Add Tax</span>
    </button>
  );
};

const TaxForm = ({
  data,
  onDelete,
  onChange,
  onSubmit,
  isSaving,
  isDeleting,
}) => {
  const { setDataToServer: updateStatusReq } = useCreate({
    refreshUrl: "tax/list",
    url: "tax/update_status",
    onSuccess: () => {
      toast.success("Tax Status Updated Successfully", {
        position: "top-right",
        duration: 3000,
      });
    },
    onError: () => {
      toast.error("Failed to Update Tax Status", {
        position: "top-right",
        duration: 3000,
      });
    },
  });

  const handleStatusChange = (e) => {
    const newStatus = e.target.checked ? 1 : 0;
    // Only call API for saved tax (should have id)
    if (data?.id) {
      updateStatusReq.mutate({
        id: data.id,
        status: newStatus,
      });
    }
  };

  return (
    <>
      <div className="border border-gray-600 p-4 rounded bg-white">
        <form className="space-y-4" onSubmit={onSubmit}>
          <div>
            <label htmlFor="Tax name" className="label">
              Tax name <small className="text-red-700">*</small>
            </label>
            <input
              required
              onChange={onChange}
              value={data.name}
              type="text"
              placeholder="Tax Name"
              name="name"
              className="input"
            />
          </div>
          <div>
            <label htmlFor="Tax value" className="label">
              Tax value <small className="text-red-700">*</small>
            </label>
            <input
              required
              onChange={onChange}
              value={data.value}
              type="number"
              placeholder="Tax value"
              name="value"
              className="input"
              onKeyDown={(e) => {
                if (["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              onWheel={(e) => e.target.blur()}
            />
          </div>
          <div>
            {/* If tax isn't saved yet, show -- instead of toggle */}
            {!data?.id ? (
              <span className="text-gray-500">--</span>
            ) : (
              <SwitchToggle
                label="Status"
                checkedValue={data.status === true || data.status === "1" || data.status === 1}
                onChange={handleStatusChange}
              />
            )}
          </div>
          <div className=" space-x-4 flex">
            <Button
              type="submit"
              variant="contained"
              className="primaryBtn-contained w-full"
            >
              Save
              {isSaving && <Spinner className={" w-8 h-8 mx-0"} />}
            </Button>
            <Button
              onClick={onDelete}
              type="button"
              color="error"
              variant="outlined"
              className="primaryBtn-contained w-full font-semibold"
            >
              Delete
              {isDeleting && <Spinner className={" w-8 h-8 mx-0"} />}
            </Button>
          </div>
        </form>
      </div>
    </>
  );
};

export default Taxes;
